module.exports = __webpack_public_path__ + "static/media/AUTO.4e568684.svg";